export const UNIT_EVENTS_GRID_CONFIG_ID = 'unit-dash-unit-events'

export const UNIT_EVENTS_GRID_CONFIG = {
  id: UNIT_EVENTS_GRID_CONFIG_ID,
  layout: {
    xxl: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 8.25, y: 0, w: 3.75, h: 5.35, static: true },
    xl: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 3.15, w: 5, h: 2.25, static: true },
    lg: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 3.35, w: 5.5, h: 2.25, static: true },
    md: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 3.25, w: 6, h: 2.25, static: true },
    sm: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 3.25, w: 6, h: 2.25, static: true },
    xs: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 3.2, w: 6.5, h: 1.8, static: true },
    xxs: { i: UNIT_EVENTS_GRID_CONFIG_ID, x: 0, y: 6, w: 12, h: 1.75, static: true }
  }
}
